module.exports = __webpack_public_path__ + "static/space.aqgk-ac7630caf0f60b8735851f624aed68ee.png";